import axios from "axios";

export const BIOMETRIC_API_BASE =
  process.env.REACT_APP_BIOMETRIC_API_URL || "https://127.0.0.1:50801/api";

export const FINGERPRINT_DEVICE_ERROR =
  "Fingerprint device not detected or configured. Please connect and configure the device.";

export interface FingerprintDevice {
  id: string;
  name: string;
}

export const isFingerprintDataUrl = (dataUrl?: string | null): boolean => {
  if (!dataUrl) return false;
  return (
    dataUrl.includes("image/jpeg") ||
    dataUrl.includes("image/jpg")
  );
};

export const detectFingerprintDevice = async (): Promise<FingerprintDevice | null> => {
  const response = await axios.get(`${BIOMETRIC_API_BASE}/devices`, {
    timeout: 10000,
  });
  const devices = response?.data?.Devices || [];
  const retcode = String(response?.data?.retcode ?? "");
  const fingerprintDeviceFound = devices.find(
    (device: { fingerprint?: string; id?: string; name?: string }) =>
      String(device?.fingerprint).toLowerCase() === "true"
  );

  if (retcode === "1" && fingerprintDeviceFound) {
    return {
      id: fingerprintDeviceFound.id,
      name: fingerprintDeviceFound.name || "BioMini",
    };
  }

  return null;
};

export const captureFingerprintImage = async (): Promise<string> => {
  const response = await axios.get(`${BIOMETRIC_API_BASE}/ScanBiomini`, {
    timeout: 60000,
  });
  const retcode = Number(response?.data?.retcode);
  const imageData = response?.data?.image?.data;
  const imageFormat = response?.data?.image?.format || "jpg";

  if (retcode === 1 && imageData) {
    return `data:image/${imageFormat};base64,${imageData}`;
  }

  throw new Error("Fingerprint capture failed");
};
